export const DEVICE_DEFAULT_MAX_SIZE = {
  lg: 1367,
  md: 1280,
  sml: 1000,
  sm: 767,
  xs: 360,
  ss: 320,
}
